import { CoreButton } from '@components'
import ErrorIcon from '@images/icons/error-icon.svg?react'
import SuccessIcon from '@images/icons/success-check.svg?react'
import { tr } from 'mmfintech-commons'
import type { ReactNode } from 'react'

import './successPane.scss'

type SuccessPaneProps = {
  customMessage?: ReactNode
  confirmMessage?: string
  response?: any
  onClick?: () => void
}

export const SuccessPane = (props: SuccessPaneProps) => {
  const { customMessage, onClick, confirmMessage = tr('FRONTEND.BUTTONS.OK', 'Ok'), response } = props

  const { status, message: responseMessage } = response || {}

  const isFailure = ['CANCELLED', 'FAILED'].includes(status)
  const failureMessage = responseMessage || tr('FRONTEND.TRANSFER.FAILED_MESSAGE', 'Transfer failed')

  return (
    <div
      className='success-pane-wrapper'
      data-test={isFailure ? 'transaction-status-failed' : 'transaction-status-success'}
    >
      <div className='success-pane-content'>
        <div className='icon'>{isFailure ? <ErrorIcon /> : <SuccessIcon />}</div>
        <div className='success-pane-message'>
          {isFailure
            ? failureMessage
            : customMessage
              ? customMessage
              : responseMessage || tr('FRONTEND.WITHDRAW.BANK_TRANSFER.SUCCESS', 'Successfully sent')}
        </div>
      </div>
      {typeof onClick === 'function' && (
        <div className='footer'>
          <CoreButton
            size='large'
            text={confirmMessage}
            onClick={onClick}
            data-test='button-ok'
            fullWidth
            variation='primary-black'
          />
        </div>
      )}
    </div>
  )
}
